module.exports = __webpack_public_path__ + "img/nav_img_cosmetics_2023.f041c4ff.png";